export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8409.873f716b.jpg";